// import 'react-app-polyfill/stable'
// import 'core-js'
// import React from 'react'
// import ReactDOM from 'react-dom'
// import App from './App'
// import reportWebVitals from './reportWebVitals'

// ReactDOM.render(
//   <Provider store={store}>
//     <App />
//   </Provider>,
//   document.getElementById('root'),
// )

// reportWebVitals()

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from 'react-redux'
import store from './store'
import reportWebVitals from "./reportWebVitals";
import axios from 'axios';

// Axios Global Configuration
axios.defaults.baseURL = 'https://api.aicee.in'; // Set your API base URL here
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('user-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>,
  </React.StrictMode>
);

reportWebVitals();
